import React from "react";
import NewDatePicker from "./NewDatePicker";

const DateOfBirthInput = (props) => {
  const { name, value, setFieldValue, ...rest } = props;

  return (
    <NewDatePicker
      {...rest}
      name={name}
      value={value}
      isFormik={true}
      IconImage={true}
      label={"Date of Birth"}
      setFieldValue={setFieldValue}
      noOptionsMessage="No Date Found"
    />
  );
};

export default DateOfBirthInput;
